<template>
  <div>
    <div class="dg-title">{{ trans("OfferCancelForm.title") }}</div>
    <p>{{ trans('OfferCancelForm.message') }}</p>

    <textarea class="form-control" v-model="commentCancel" :options="offerId"></textarea>

    <p align="right"><small>{{ trans('OfferCancelForm.note') }}</small></p>
    <button @click="cancelOffer" class="btn btn-primary btn-cons m-t-15 pull-left btn-confirm" :options="store">
      {{ trans("OfferCancelForm.buttons.confirm") }}</button>
    <button @click="closeOfferCancelForm" class="btn btn-default m-t-15 pull-right btn-cancel">
      {{ trans("OfferCancelForm.buttons.close") }}</button>
    <div class="clearfix"></div>
  </div>
</template>

<script type="text/javascript">
  import DialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';
  import i18n from '@/lang'
  import ie_mixin from '@/mixin/ie'

  export default {
    name: "OfferCancelForm",
    mixins: [DialogMixin, ie_mixin],
    data: function(){
      return {
        commentCancel: "",
        offerId: "",
        store: ""
      }
    },
    methods: {
      trans(text){
        return i18n.t(text);
      },
      closeOfferCancelForm() {
        this.$emit('close');
      },
      cancelOffer() {
        if (this.options.store) {
          this.options.store.dispatch('offers/cancelOffer',
            {offerId: this.options.offerId, commentCancel: this.commentCancel})
        }
        this.$emit('close');
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/offers/OfferCancelForm.vue